import ExcelJS from "exceljs";
import { saveAs } from 'file-saver';
import DrawExcel from "@/commonFuncion/DrawExcel";

export async function exportExcelToSheet(exportToExcelData, dataListTable) {
    const fileName = exportToExcelData.nameFile;
    const workbook = new ExcelJS.Workbook();

    for (let i = 0; i < dataListTable.length; i++) {
        // Name each sheet tab by kid's name and ID (trimmed to fit Excel's 31-character limit)
        let sheetName = `${dataListTable[i].fullName}-${dataListTable[i].id}`;
        if (sheetName.length > 30) {
            sheetName = sheetName.substring(0, 30);
        }
        await addDataList(workbook, sheetName, dataListTable[i].dataList, dataListTable[i].fullName);
    }

    async function addDataList(workbook, sheetName, data, name) {
        const titleFile = exportToExcelData.titleFile;
        const columnHeaders = exportToExcelData.columnHeaders;
        const companyInfo = exportToExcelData.companyInfo;
        const columnWidths = exportToExcelData.columnWidths;

        const worksheet = workbook.addWorksheet(sheetName);

        // Apply column widths
        await DrawExcel.drawColumnWidths(columnWidths, worksheet);

        // Process companyInfo to remove URL and split phone and email
        let processedCompanyInfo = [];
        if (Array.isArray(companyInfo)) {
            companyInfo.forEach(info => {
                if (info.toLowerCase().startsWith('url:')) {
                    return;
                }
                if (info.includes('SDT:') && info.includes('Email:')) {
                    const parts = info.split(',');
                    const sdtPart = parts[0].trim().replace('SDT:', 'SĐT:');
                    const emailPart = parts[1] ? parts[1].trim() : '';
                    processedCompanyInfo.push(sdtPart);
                    if (emailPart) {
                        processedCompanyInfo.push(emailPart);
                    }
                } else {
                    processedCompanyInfo.push(info);
                }
            });
        } else {
            processedCompanyInfo = companyInfo;
        }

        // Draw company info (Rows 1-4)
        await DrawExcel.drawCompanyInfo(processedCompanyInfo, worksheet);

        // Styling company info rows
        for (let r = 1; r <= 4; r++) {
            const row = worksheet.getRow(r);
            row.height = 20;
            row.eachCell((cell) => {
                cell.font = { name: 'Segoe UI', size: 10, bold: true, color: { argb: 'FFC00000' } };
                cell.alignment = { vertical: 'middle', horizontal: 'left', indent: 1 };
            });
        }

        // Title Row (Row 5)
        await DrawExcel.drawTitleRow(titleFile, worksheet);
        const titleRow = worksheet.getRow(5);
        titleRow.height = 28;
        titleRow.eachCell((cell) => {
            cell.font = { name: 'Segoe UI', size: 16, bold: true, color: { argb: 'FF1F497D' } }; // Elegant Dark Blue
            cell.alignment = { vertical: 'middle', horizontal: 'left', indent: 1 };
        });

        // Add blank row (Row 6)
        worksheet.addRow([]);
        const blankRow = worksheet.getRow(6);
        blankRow.height = 15;

        // Row 7 is the merged header row
        const groupHeaderRow = worksheet.getRow(7);
        groupHeaderRow.height = 26;

        // Define modern pastel colors
        const colors = {
            classBg: 'FFFDF2E9',      // Soft warm cream
            weightBg: 'FFE2EFDA',     // Soft pastel mint green
            heightBg: 'FFD9E1F2',     // Soft pastel sky blue
            bmiBg: 'FFEBF1DE',        // Soft pastel sage green
            noteBg: 'FFFCE4D6',       // Soft pastel light peach/rose
            headerBg: 'FFF2F2F2',     // Professional light gray
            textDark: 'FF333333',     // Elegant charcoal
            borderGray: 'FFD3D3D3',   // Soft gray border
        };

        const borderStyle = {
            top: { style: 'thin', color: { argb: colors.borderGray } },
            left: { style: 'thin', color: { argb: colors.borderGray } },
            bottom: { style: 'thin', color: { argb: colors.borderGray } },
            right: { style: 'thin', color: { argb: colors.borderGray } }
        };

        // Helper to style a merged group
        const styleMergedRange = (sheet, range, val, bg) => {
            sheet.mergeCells(range);
            const [startCellRef] = range.split(':');
            const cell = sheet.getCell(startCellRef);
            cell.value = val;
            cell.font = { name: 'Segoe UI', size: 11, bold: true, color: { argb: colors.textDark } };
            cell.alignment = { vertical: 'middle', horizontal: 'center', wrapText: true };
            
            const [startCol, startRow, endCol, endRow] = decodeRange(range);
            for (let r = startRow; r <= endRow; r++) {
                for (let c = startCol; c <= endCol; c++) {
                    const rangeCell = sheet.getCell(r, c);
                    rangeCell.fill = {
                        type: 'pattern',
                        pattern: 'solid',
                        fgColor: { argb: bg }
                    };
                    rangeCell.border = borderStyle;
                }
            }
        };

        function decodeRange(rangeStr) {
            const parts = rangeStr.split(':');
            const start = parseCell(parts[0]);
            const end = parts[1] ? parseCell(parts[1]) : start;
            return [start.col, start.row, end.col, end.row];
        }

        function parseCell(cellStr) {
            const match = cellStr.match(/^([A-Z]+)([0-9]+)$/);
            const colStr = match[1];
            const row = parseInt(match[2], 10);
            let col = 0;
            for (let i = 0; i < colStr.length; i++) {
                col = col * 26 + (colStr.charCodeAt(i) - 64);
            }
            return { col, row };
        }

        // Apply merged header ranges on Row 7
        const sttTopCell = worksheet.getCell('A7');
        sttTopCell.fill = { type: 'pattern', pattern: 'solid', fgColor: { argb: colors.headerBg } };
        sttTopCell.border = borderStyle;

        styleMergedRange(worksheet, 'B7:F7', name, colors.classBg);
        styleMergedRange(worksheet, 'G7:K7', "Đánh giá cân nặng theo tháng tuổi", colors.weightBg);
        styleMergedRange(worksheet, 'L7:P7', "Đánh giá chiều cao theo tháng tuổi", colors.heightBg);
        styleMergedRange(worksheet, 'Q7:U7', "Đánh giá BMI theo tháng tuổi", colors.bmiBg);
        styleMergedRange(worksheet, 'V7:V7', "Ghi chú", colors.noteBg);

        // Row 8: Table Headers
        const headerRow = worksheet.getRow(8);
        headerRow.height = 30;
        columnHeaders.forEach((header, index) => {
            const cell = headerRow.getCell(index + 1);
            cell.value = header;
            cell.fill = {
                type: 'pattern',
                pattern: 'solid',
                fgColor: { argb: colors.headerBg }
            };
            cell.font = {
                name: 'Segoe UI',
                size: 10,
                bold: true,
                color: { argb: colors.textDark }
            };
            cell.alignment = {
                horizontal: 'center',
                vertical: 'middle',
                wrapText: true
            };
            cell.border = borderStyle;
        });

        // Row 9+: Data rows
        if (data.length === 0) {
            worksheet.mergeCells(`A9:V9`);
            const a = worksheet.getRow(9);
            const onBottom = a.getCell("A");
            onBottom.value = "Không có dữ liệu chiều cao, cân nặng đầy đủ hoặc chưa đo lần nào";
            onBottom.alignment = {horizontal: 'center', vertical: 'middle', wrapText: true};
            onBottom.font = {
                name: 'Segoe UI',
                color: {argb: 'FFFF0000'},
                size: 11,
                bold: true
            };
            onBottom.border = borderStyle;
            
            // Also style the merged range cells to have borders
            const rangeCellB = worksheet.getCell('B9');
            rangeCellB.border = borderStyle;
        } else {
            data.forEach((rowData) => {
                const addedRow = worksheet.addRow(rowData);
                addedRow.height = 22;
                
                addedRow.eachCell({ includeEmpty: true }, (cell, colNumber) => {
                    cell.font = { name: 'Segoe UI', size: 10, color: { argb: 'FF444444' } };
                    cell.border = borderStyle;
                    
                    if (cell.value === 'x') {
                        cell.font = { name: 'Segoe UI', size: 10, bold: true, color: { argb: 'FF2E7D32' } };
                    }

                    // Alignment by column
                    if (colNumber === 1) { // STT
                        cell.alignment = { horizontal: 'center', vertical: 'middle' };
                    } else if (colNumber === 2) { // Ngày cân đo
                        cell.alignment = { horizontal: 'center', vertical: 'middle' };
                    } else if (colNumber === 3) { // Tuổi
                        cell.alignment = { horizontal: 'center', vertical: 'middle' };
                    } else if (colNumber === 4 || colNumber === 5 || colNumber === 6) { // Cân nặng, Chiều cao, BMI
                        cell.alignment = { horizontal: 'right', vertical: 'middle' };
                        if (typeof cell.value === 'number') {
                            cell.numFmt = '#,##0.00';
                        }
                    } else if (colNumber >= 7 && colNumber <= 21) { // Evaluation marks 'x'
                        cell.alignment = { horizontal: 'center', vertical: 'middle' };
                    } else { // Note
                        cell.alignment = { horizontal: 'left', vertical: 'middle', indent: 1 };
                    }
                });
            });
        }
    }

    const buffer = await workbook.xlsx.writeBuffer();
    saveAs(new Blob([buffer], { type: 'application/octet-stream' }), fileName + '.xlsx');
}
